export function sortNotificationsDesc(notifications) {
    return notifications.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
}
//# sourceMappingURL=helpers.js.map